import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import debounce from 'lodash/debounce';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { BatchAdjustmentPropType } from './propTypes';
import { importValidationColumnDefinition } from '../../shared/columnDefinitions';
import WithIndicatorCellRenderer from './WithIndicatorCellRenderer';
import columnDefs from '../../shared/columnDefinitions/batchAdjustments';

const rebuildReactTooltip = debounce(ReactTooltip.rebuild, 200);

const appendCustomRenderer = columnDefs => columnDefs.map(columnDef => ({
  ...columnDef,
  cellRenderer: WithIndicatorCellRenderer(columnDef.cellRenderer),
}));

class BatchAdjustmentsGrid extends PureComponent {
  static propTypes = {
    batchAdjustments: PropTypes.arrayOf(BatchAdjustmentPropType),
    importErrors: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  componentDidUpdate = prevProps => {
    if (prevProps.batchAdjustments !== this.props.batchAdjustments) {
      rebuildReactTooltip();
    }
  };

  onGridReady = ({ api }) => {
    api.addEventListener('bodyScroll', rebuildReactTooltip);
  };

  onRowDataUpdated = params => {
    if (params.gridApi) {
      params.gridApi.applyColumnState({
        state: [
          { colId: importValidationColumnDefinition.field, sort: 'asc' },
        ],
      });
    }
  };

  render() {
    const { batchAdjustments, importErrors, isLoading } = this.props;

    const rowData = batchAdjustments.map(batchAdjustment => {
      if (batchAdjustment.validationData) {
        return {
          ...batchAdjustment,
          IMPORT_VALIDATION: [].concat(...Object.values(batchAdjustment.validationData)).map(error => error.message).join(', '),
        };
      }
      return batchAdjustment;
    });

    const columnDefinitions = [
      ...(importErrors ? [importValidationColumnDefinition] : []),
      ...appendCustomRenderer(columnDefs),
    ];

    if (!importErrors) {
      columnDefinitions[0].sort = 'asc';
    }

    return (
      <div className="batch-adjustments-grid page-content-container">
        { batchAdjustments.length > 0
          && (
            <div className="text-center">
              {`Import complete. ${batchAdjustments.length} records loaded`}
              {`, ${importErrors} with errors`}
            </div>
          )
        }
        <div className="ag-theme-bootstrap">
          <AgGrid
            columnDefs={columnDefinitions}
            headerHeight={50}
            rowData={rowData}
            onGridReady={this.onGridReady}
            onRowDataUpdated={this.onRowDataUpdated}
            isGridLoading={isLoading}
          />
          <ReactTooltip place="right" effect="float" />
        </div>
      </div>
    );
  }
}

export default BatchAdjustmentsGrid;
